import { ErrorBoundary } from 'react-error-boundary'
import { ErrorFallback } from '@velasca/ui/error-fallback'

export const withErrorBoundary = (WrappedComponent: any) => {
  return function (props: any) {
    return (
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <WrappedComponent {...props} />
      </ErrorBoundary>
    )
  }
}
